import { get } from 'lodash';
import { connect } from 'react-redux';

import PdpZoomView from 'components/PdpZoomView';
import * as actions from 'state/actions';
import { getSlides, zoomViewModalIsOpen, getCurrentMainCarouselSlide } from 'state/selectors/pdp';
import MathUtil from 'utils/Math';
import Rudderstack from 'utils/Rudderstack';

const mapStateToProps = state => {
  const isOpen = zoomViewModalIsOpen(state);
  const currentMainCarouselSlide = getCurrentMainCarouselSlide(state);
  const slides = getSlides(state);

  const nSlides = get(slides, 'length');

  const nextMainCarouselSlide = MathUtil.mod(currentMainCarouselSlide + 1, nSlides);
  const previousMainCarouselSlide = MathUtil.mod(currentMainCarouselSlide - 1, nSlides);

  return {
    isOpen,
    previousMainCarouselSlide,
    currentMainCarouselSlide,
    nextMainCarouselSlide,
    slides,
  };
};

const mapDispatchToProps = dispatch => ({
  closeModal: () => dispatch(actions.closeModal()),
  setCurrentMainCarouselSlide: index => dispatch(actions.setCurrentMainCarouselSlide(index)),
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  setNextMainCarouselSlide: () => {
    dispatchProps.setCurrentMainCarouselSlide(stateProps.nextMainCarouselSlide);
    Rudderstack.productImageScroll({
      index: stateProps.nextMainCarouselSlide,
      product: ownProps.product,
    });
  },
  setPreviousMainCarouselSlide: () => {
    dispatchProps.setCurrentMainCarouselSlide(stateProps.previousMainCarouselSlide);
    Rudderstack.productImageScroll({
      index: stateProps.previousMainCarouselSlide,
      product: ownProps.product,
    });
  },
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(PdpZoomView);
